<template>
  <div>
    <LmListV2
      ref='LmCustomerCodificatorBuilderListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado Codificadores Builder',
      gqlField: 'CustomerCodificatorBuilder',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[CustomerCodificatorBuilderESSortEnum]) {
          CustomerCodificatorBuilder(
            titleList: "Listado Codificadores Builder"
            aggs: []
            q: $q
            perPage: 10
            page: $page
            sort: $sort
            metaSearch: "*"
            opts: {
            lenient: true
            }
            lmPathActions: [{to:"/listbuilder/view/:listbuilderId",tooltip:"Ver",fontAwesomeIcon:"search"},{to:"/customercodificadoresbuilder/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
            lmModalActions: []
            buttonLinks: [{value:"Nuevo",to:"/customercodificadoresbuilder/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info",buttonColor:"#17a2b8",enableOnSelectedRows:false,type:"redirect",requestEndpoint:"",requestConfirmation:false}]
            ) {
            count
            searcher
            tableItemsTotal
            titleList
            filter {
            aggregatesToSelect
            }
            table {
                items {
                    codificatorName,updatedAt,createdAt,deleted,actions
                }
                fields {
                    key
                    label
                    sortable
                }
            }
            buttons
            pagination
        }
    }`,
      searchOnFieldsSelected: [
        'customerId',
        'codificatorName',
        'createdAt',
        'updatedAt',
        'listbuilderId',
        'deleted',
        'formbuilderId',
        'isChild',
        'lumbreInternal',
        'createdBy',
        'updatedBy',
        'actions'
      ],
      searchOnFieldsToSelected: [
        'customerId',
        'codificatorName',
        'createdAt',
        'updatedAt',
        'listbuilderId',
        'deleted',
        'formbuilderId',
        'isChild',
        'lumbreInternal',
        'createdBy',
        'updatedBy',
        'actions'
      ],
      items: [
        {
          name: 'customerId',
          description: 'ID del cliente'
        },
        {
          name: 'codificatorName',
          description: 'Nombre'
        },
        {
          name: 'createdAt',
          description: 'Creado'
        },
        {
          name: 'updatedAt',
          description: 'Actualizado'
        },
        {
          name: 'listbuilderId',
          description: 'listbuilder ID'
        },
        {
          name: 'deleted',
          description: 'En baja lógica'
        },
        {
          name: 'formbuilderId',
          description: 'formbuilder ID'
        },
        {
          name: 'isChild',
          description: 'Es hijo'
        },
        {
          name: 'lumbreInternal',
          description: 'Lumbre Internal Field'
        },
        {
          name: 'createdBy',
          description: 'Creado por'
        },
        {
          name: 'updatedBy',
          description: 'Actualizado por'
        },
        {
          name: 'actions',
          description: 'Acciones'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [{
        key: 'codificatorName',
        label: 'Nombre',
        sortable: false
      },
      {
        key: 'updatedAt',
        label: 'Actualizado',
        sortable: true
      },
      {
        key: 'createdAt',
        label: 'Creado',
        sortable: true
      },
      {
        key: 'deleted',
        label: 'En baja lógica',
        sortable: true
      },
      {
        key: 'actions',
        label: 'Acciones',
        sortable: false
      }]
    }
  }
}
</script>
